module.exports = __webpack_public_path__ + "assets/headset-mic-1.36088dee.svg";